<template>
	<div class="timepicker flex between-v">
		<div class="picker flex between">
			<!-- 时 -->
			<div class="swiper-container">
				<div class="swiper swiper0">
					<div class="swiper-wrapper">
						<div :class="index===selectedTime.hour?'select':''" class="swiper-slide flex center" v-for="(item,index) in 24" :key="index">{{index}}时</div>
					</div>
				</div>
			</div>
			<div style="color:#ffa216;font-weight:bold">:</div>
			<!-- 分 -->
			<div class="swiper-container">
				<div class="swiper swiper1">
					<div class="swiper-wrapper">
						<div :class="item===selectedTime.minute?'select':''" class="swiper-slide flex center" v-for="(item,index) in minutes" :key="index">{{item}}分</div>
					</div>
				</div>
			</div>

			<!-- 秒 -->
			<!-- <div class="swiper-container">
				<div class="swiper swiper2">
					<div class="swiper-wrapper">
						<div :class="item===selectedTime.day?'select':''" class="swiper-slide flex center" v-for="(item,index) in days" :key="index">{{item}}日</div>
					</div>
				</div>
			</div> -->
			<div class="selectbar"></div>
		</div>
	</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/swiper-bundle.min.css";
export default {
	data() {
		return {
			selectedTime: {
				hour: 0,
				minute: 0,
			},

			minutes:[0,5,10,15,20,25,30,35,40,45,50,55],

			swiper0: null,
			swiper1: null,

			config: {
				autoplay: false,
				direction: "vertical",
				slidesPerView: 3,
				centeredSlides: true,
				spaceBetween: 5,

				observer: true, // 修改 swiper 自己或子元素时，自动初始化 swiper
				observeParents: true, //修改swiper的父元素时，自动初始化swiper

				// virtual: {
				// 	slides: (function () {
				// 		const slides = [];
				// 		for (var i = 0; i < 50; i += 1) {
				// 			slides.push("Slide " + (i + 1));
				// 		}
				// 		return slides;
				// 	})(),
				// },
			},
		};
	},


	watch:{
		"selectedTime.hour":{
			handler(){
				this.resetTime();
			},
		},
		"selectedTime.minute":{
			handler(){
				this.resetTime();
			},
		}
	},

	mounted() {
		this.initSwiper(0);
		this.initSwiper(1);
	},

	methods: {
		// type 0-时 1-分
		initSwiper(type) {
			this[`swiper${type}`] = new Swiper(`.swiper${type}`, {
				...this.config,
				on: this.onSlideChange(type),
			});
		},

		// type 0-时 1-分
		onSlideChange(type) {
			let that = this;
			return {
				slideChangeTransitionEnd: function () {
					// this->swiper
					if (type === 0)
						that.selectedTime.hour = this.activeIndex;
					else if (type === 1)
						that.selectedTime.minute = that.minutes[this.activeIndex];
				},
			};
		},

		resetTime(){
			let {hour,minute} = this.selectedTime;
			hour=hour<10?'0'+hour:''+hour;
			minute=minute<10?'0'+minute:''+minute;
			this.$emit("timeChange", hour+':'+minute+':00');
		}
	},
};
</script>


<style lang="less" scoped>
.timepicker {
	width: 100%;
	padding: 0 0 27/@rem;
	.picker {
		width: 100%;
		position: relative;
		.selectbar {
			width: 100%;
			height: 48/@rem;
			position: absolute;
			left: 0;
			top: 50%;
			margin-top: -24/@rem;
			border-image: linear-gradient(to right,white,rgba(254, 198, 51, 1),white)30 30;
			border-top: 2/@rem solid;
			border-bottom: 2/@rem solid;
		}
		&::after {
			content: "";
			z-index: 1001;
			width: 100%;
			height: 100%;
			position: absolute;
			background-image: linear-gradient(
				to bottom,
				rgba(255, 255, 255, 0.5),
				rgba(255, 255, 255, 0),
				rgba(255, 255, 255, 0.5)
			);
			pointer-events: none;
		}
	}
	.btn-full {
		margin-top: 10/@rem;
	}
}

.swiper {
	height: 150/@rem;
}
.swiper-container {
	z-index: 1000;
	width: 100%;
	.swiper-slide {
		font-size: 15/@rem;
		color: rgba(31, 30, 29, 0.7);
	}
	.select {
		color: #ffa216;
		font-size: 20/@rem;
	}
}
</style>